export default __webpack_public_path__ + "static/media/customer-icon.e8e24511.svg";